import React, { useEffect, useRef } from "react";
import { Chart } from "chart.js/auto";

/**
 * EuleriagymVisualConditionChart
 * Mostra un doughnut chart con percentuale e testo centrale.
 *
 * Props:
 * - value: numero (es. 15.4)
 * - label: string (es. "OCCHI APERTI")
 * - colors: array di 2 colori [colore1, colore2]
 */
function DoughnutChart({
  value1 = 0,
  value2 = 0,
  labels = ["", ""],
  colors = ["#FFA411", "#A778FF"],
}) {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    if (chartRef.current) {
      chartRef.current.destroy();
    }

    let label = '';
    // 🔹 Plugin per il testo al centro
    const centerTextPlugin = {
      id: "centerText",
      beforeDraw(chart) {
        const { ctx, chartArea } = chart;
        const { width, height } = chartArea;
        ctx.save();

        ctx.textAlign = "center";
        ctx.textBaseline = "middle";

        // Percentuale
        ctx.font = "bold 16px Montserrat, sans-serif";
        ctx.fillStyle = "#fff";

        // Calcolo percentuale sbilanciamento
        let displayText = "";
        const total = value1 + value2;
        let colorLabel = "#b0b5be";
        if (total > 0) {
          if (value1 === value2) {
            displayText = "";
            label = "-";
          } else {
            value1 = value1 === 0 ? 0.01 : value1; // Evita divisione per zero
            value2 = value2 === 0 ? 0.01 : value2;
            const perc1 = (value2 / value1);
            const perc2 = (value2 / total) * 100;
            const diff = perc1 - perc2;

            // Determina segno in base al direction
            label = perc1 > 1 ? labels[1] : labels[0];
            colorLabel = perc1 > 1 ? colors[1] : colors[0];

            const baseDiff = Math.abs(perc1).toFixed(1);

            displayText = `${baseDiff}`;
          }
        }
        ctx.fillText(
          displayText,
          width / 2 + chartArea.left / 2,
          height / 2 + chartArea.top / 2 - 12
        );

        // Label
        // Label su due righe (sempre due parole)
        ctx.font = "10px Montserrat, sans-serif";
        ctx.fillStyle = colorLabel;

        const words = label.toUpperCase().split(" ");
        const line1 = words[0] || "";
        const line2 = words[1] || "";

        // Posizione verticale di base
        const centerX = width / 2 + chartArea.left / 2;
        const centerY = height / 2 + chartArea.top / 2;

        ctx.fillText(line1, centerX, centerY + 8);  // prima riga
        ctx.fillText(line2, centerX, centerY + 18);  // seconda riga

        ctx.restore();
      },
    };

    const config = {
      type: "doughnut",
      data: {
        datasets: [
          {
            data: [value1, value2],
            backgroundColor: colors,
            borderWidth: 10,
            borderRadius: 15

          },
        ],
      },

      options: {
        responsive: false,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
          tooltips: {
            mode: 'disabled'
          }
        },
        animation: {
          duration: 0,
        },
        borderColor: 'rgba(0, 0, 0, 0)',
        cutout: 43,
        rotation: 180,
      },
      plugins: [centerTextPlugin], // 👈 qui viene caricato il plugin
    };

    chartRef.current = new Chart(canvasRef.current, config);

    return () => {
      chartRef.current.destroy();
    };
  }, [value1, value2, labels, colors]);

  return (
    <div style={{ textAlign: "center", width: "120px", margin: "20px auto" }}>
      <canvas ref={canvasRef} width="115" height="115" />
    </div>
  );
}

export default DoughnutChart;
